module.exports = __webpack_public_path__ + "static/img/dominate1.254928d3.png";